<template>

  <card class="p-grid p-col-12" :class="store.getLayoutColor() !== 'dark' ? 'certificate-'+certificateOrder : ''">
    <coff-input-select v-model="certificate.typeOfCertificate" label="protocol.tab-checklist.form.type-of-certificate" class="p-col-12 p-md-3 p-lg-3" @change="updateCertificateDate(person)" :options="typeOfCertificates" option-value="id" :error="!certificate.typeOfCertificate"/>
    <coff-input-select v-model="certificate.typeOfDocument" label="protocol.tab-checklist.form.type-of-document" class="p-col-12 p-md-3 p-lg-3" :options="typeOfDocument" option-value="id" :error="!certificate.typeOfDocument"/>
    <coff-input-date v-if="showField(certificate, 'dataCertificate')" v-model="certificate.dataCertificate" label="protocol.tab-checklist.form.date" class="p-col-12 p-md-3 p-lg-3" :max-date="new Date()" :error="!certificate.dataCertificate"/>
    <coff-input-date v-if="isBirthCertificate" v-model="certificate.dataCertificate" label="forms.client.birthDay" class="p-col-12 p-md-3 p-lg-3" :disabled="true"/>
    <coff-input-date v-if="isDeathCertificate" v-model="certificate.dataCertificate" label="forms.client.deathDay" class="p-col-12 p-md-3 p-lg-3" :disabled="true"/>
<!--<coff-input-text v-if="showField(certificate, 'place')" v-model="certificate.place" label="protocol.tab-checklist.form.place" class="p-col-12 p-md-3 p-lg-3" :error="!certificate.place"/>
    <coff-input-text v-if="showField(certificate, 'spouseName')" v-model="certificate.spouseName" label="protocol.tab-checklist.form.spouseName" class="p-col-12 p-md-12 p-lg-12" :error="!certificate.spouseName"/>-->
    <coff-input-text v-if="showField(certificate, 'address')" v-model="certificate.address" label="protocol.tab-checklist.form.address" class="p-col-12 p-md-12 p-lg-12" :error="!certificate.address"/>
    <coff-input-text v-if="showField(certificate, 'addressReferenceName')" v-model="certificate.addressReferenceName" label="protocol.tab-checklist.form.addressReferenceName" class="p-col-12 p-md-12 p-lg-12" :error="!certificate.addressReferenceName"/>
    <coff-input-text v-if="showField(certificate, 'personNameInDocument')" v-model="certificate.personNameInDocument" label="protocol.tab-checklist.form.personNameInDocument" class="p-col-12 p-md-12 p-lg-12" :error="!certificate.personNameInDocument"/>

    <template v-if="certificate.typeOfCertificate === 'REFERENCE'">
        <div class="p-col-10" />
        <coff-input-auto-complete v-model="certificate.processReferencePerson" label="protocol.tab-checklist.form.processReferencePerson" class="p-col-10 p-md-4 p-lg-4"  :itens="clients" field="name" :func-suggestions="searchClient" :error="!certificate.processReferencePerson"/>
        <div class="p-mt-5 text-vertical-center">
            <a class="cursor-pointer p-md-1 " @click.prevent="modalClientCertificate('processReferencePerson')"><i class="pi pi-users" :title="$t('menu.client.form')"/></a>
        </div>
    </template>

    <coff-input-text-editor v-model="certificate.notes" label="protocol.tab-checklist.form.notes" :content_css="content_css" :skin="skin" class="p-col-12 p-md-12 p-lg-12"/>

    <template v-if="certificate.typeOfCertificate !== 'REFERENCE'">
        <coff-input-select v-model="certificate.statusDocument" label="protocol.tab-checklist.form.status-document" class="p-col-12 p-md-6 p-lg-3" :class="colorStatusDocument" :options="statusDocuments" option-value="id" :translate="true" :error="!certificate.statusDocument"/>
        <coff-input-select v-model="certificate.statusTranslate" label="protocol.tab-checklist.form.status-translation" class="p-col-12 p-md-6 p-lg-3" :class="colorStatusTranslation" :options="statusTranslates" option-value="id" :translate="true" :error="!certificate.statusTranslate"/>
        <span class="p-col-12" />
        <coff-input-money v-model="certificate.price" label="protocol.tab-checklist.form.price" class="p-col-12 p-md-6 p-lg-3" :error="certificate.price === '0,00'"/>
        <coff-input-money v-if="certificate.statusTranslate !== 'NOT_NECESSARY'" v-model="certificate.translatePrice" label="protocol.tab-checklist.form.translate-price" class="p-col-12 p-md-6 p-lg-3" :error="certificate.translatePrice === '0,00'"/>
        <coff-input-money v-model="certificate.otherPrices" label="protocol.tab-checklist.form.other-prices" class="p-col-12 p-md-6 p-lg-3" :class="certificate.otherPrices === '0,00' ? 'coff-input-warning' : ''"/>
    </template>

    <Message class="p-col-12" v-for="(msg, index) of errors" severity="error" :key="index">{{msg}}</Message>
    <div class="p-col-12">
      <span v-if="saveStatus === 'saving'" class="save-status save-status--saving">
        <i class="pi pi-spin pi-spinner"/> {{ $t('protocol.tab-checklist.auto-save.saving') }}
      </span>
      <span v-else-if="saveStatus === 'saved'" class="save-status save-status--saved">
        <i class="pi pi-check"/> {{ $t('protocol.tab-checklist.auto-save.saved') }}
      </span>
      <span v-else-if="saveStatus === 'conflict'" class="save-status save-status--conflict">
        <i class="pi pi-exclamation-triangle"/> {{ $t('protocol.tab-checklist.auto-save.conflict') }}
      </span>
      <span v-else-if="saveStatus === 'error'" class="save-status save-status--error">
        <i class="pi pi-times"/> {{ $t('protocol.tab-checklist.auto-save.error') }}
      </span>
    </div>
    <div class="p-col-12 p-text-right" v-if="canDelete">
      <Button class="p-button-danger" :label="$t('protocol.tab-checklist.delete-certificate')" @click="deleteCertificate"/>
    </div>

    <ancestryline-progress-bar :value="calculateProgress(certificate)" />
  </card>

</template>

<script>

import {
    TYPE_OF_CERTIFICATES,
    WEDDING,
    BIRTH,
    IDENTIFICATION,
    DEATH,
    ADDRESS_PROOF
} from "@/constants/TypeOfCertificates";
import EventBus from "@/commons/EventBus";
import {
    _getTypeOfDocuments,
    RELIGIOUS,
    NORMAL,
    BAPTISM,
    CIVIL,
    ADDRESS_PROOF_ADDRESS,
} from "@/constants/TypeOfDocuments";
import CertificateProtocolBusiness from "@/business/CertificateProtocolBusiness";
import store from "@/store";
import DateUtils from "@/utils/DateUtils";
import ClientBusiness from "@/business/ClientBusiness";
import DialogService from "@/business/ModalBusiness";
import ModalClientForm from "@/viewer/client/ModalClientForm.vue";

export default {
  name: "Certificate",

  props: {
    certificate: {type: Object, default: () => {return{}}},
    person: {type: Object, default: () => {return{}}},
    errors: {type: Array, default: () => {return[]}},
    canDelete: {type: Boolean, default: true},
    certificateOrder: {type: Number, default: 1},
  },

  mounted() {
      this.convertDate(this.certificate.dataCertificate);
      if (this.certificate.typeOfCertificate === BIRTH && [BAPTISM, CIVIL].includes(this.certificate.typeOfDocument)) {
        this.certificate.dataCertificate = DateUtils.toStringDate(this.certificate.checklistProtocolPerson.person.birthDay);
      }
      this.$nextTick(() => {
        this.isInitializing = false;
      });
  },

  data() {
    return {
      skin: null,
      clients: [],
      typeOfCertificates: TYPE_OF_CERTIFICATES,
      saveStatus: 'idle',
      saveTimer: null,
      isSaving: false,
      isInitializing: true,
      statusDocuments: [
          {id: 'OFFICE', name: 'enumerations.documents.in-office'},
          {id: 'PENDING', name: 'enumerations.documents.pending'},
      ],
      statusTranslates: [
          {id: 'OFFICE', name: 'enumerations.documents.in-office'},
          {id: 'TRANSLATING', name: 'enumerations.documents.send-translator'},
          {id: 'NOT_NECESSARY', name: 'enumerations.documents.not-necessary'},
          {id: 'PENDING', name: 'enumerations.documents.pending'},
      ],
      booleanOptions: [
        {value: true, label: 'field.default.yes'},
        {value: false, label: 'field.default.no'}
      ],
      content_css: null,
    }
  },

  watch: {
      'certificate.dataCertificate': function(value) {
          this.convertDate(value);
      },
      certificate: {
          deep: true,
          handler() {
              if (this.isSaving || this.isInitializing) return;
              this.scheduleAutoSave();
          }
      },
  },

  computed: {
    store() {
        return store
    },
    typeOfDocument(){
      return this.getTypeOfDocuments(this.certificate.typeOfCertificate);
    },
    colorStatusDocument() {
      return this.certificate.statusDocument === 'OFFICE' ? 'coff-input-success' : this.certificate.statusDocument === 'PENDING' ? 'coff-input-warning' : '';
    },
    colorStatusTranslation() {
        return ['NOT_NECESSARY', 'OFFICE'].includes(this.certificate.statusTranslate) ? 'coff-input-success' : ['TRANSLATING', 'PENDING'].includes(this.certificate.statusTranslate) ? 'coff-input-warning' : '';
    },
    isBirthCertificate() {
      return (this.certificate.typeOfCertificate === BIRTH && [BAPTISM, CIVIL].includes(this.certificate.typeOfDocument));
    },
    isDeathCertificate() {
      return (this.certificate.typeOfCertificate === DEATH && [RELIGIOUS, NORMAL].includes(this.certificate.typeOfDocument));
    }
  },

  created() {
    if(store.getLayoutColor() === this.dark){
      this.content_css = 'dark';
      this.skin = 'oxide-dark';
    }
  },

  methods: {

    updateCertificateDate(person) {
      if (this.certificate.typeOfCertificate === BIRTH) {
        this.convertDate(person.birthDay);
      }
      if (this.certificate.typeOfCertificate === DEATH) {
        this.convertDate(person.deathDay);
      }
    },

    convertDate(value) {
        if (!(value instanceof Date) && value) {
            this.certificate.dataCertificate = DateUtils.toStringDate(value);
        }
    },

    deleteCertificate(){
      EventBus.$emit('DELETE_CERTIFICATE', this.certificate);
    },

    showField(certificate, fieldName) {
      switch (fieldName) {
          case 'place': {
              return (
                  certificate.typeOfCertificate === BIRTH && [BAPTISM, CIVIL].includes(certificate.typeOfDocument) ||
                  certificate.typeOfCertificate === DEATH && [NORMAL, RELIGIOUS].includes(certificate.typeOfDocument)
              );
          }
          case 'personNameInDocument': {
              return certificate.typeOfCertificate === IDENTIFICATION;
          }
          case 'spouseName': {
              return (
                  certificate.typeOfCertificate === WEDDING && [CIVIL, RELIGIOUS].includes(certificate.typeOfDocument)
              );
          }
          case 'dataCertificate': {
              return (
                  certificate.typeOfCertificate === WEDDING && [CIVIL, RELIGIOUS].includes(certificate.typeOfDocument)
              );
          }
          case 'address': {
              return (
                  certificate.typeOfCertificate === ADDRESS_PROOF && [ADDRESS_PROOF_ADDRESS].includes(certificate.typeOfDocument)
              );
          }
          case 'addressReferenceName': {
              return (
                  certificate.typeOfCertificate === ADDRESS_PROOF && !['ADDRESS_PROOF_OWN', 'ADDRESS_PROOF_ADDRESS'].includes(certificate.typeOfDocument)
              );
          }
          default: return true;
      }
    },

    async searchClient(name){
        return await ClientBusiness.search(name);
    },

    async modalClientCertificate(field){
        const clientId = this.certificate[field] ? this.certificate[field].id : undefined;
        const client = await DialogService.openModal(ModalClientForm, {clientId}, 1000);
        if(client){
            this.$set(this.certificate, field, client);
        }
    },

    getTypeOfDocuments: _getTypeOfDocuments,
    calculateProgress: CertificateProtocolBusiness.calculateProgress,

    async reloadCertificate() {
      if (!this.certificate.id) return;
      try {
        const fresh = await CertificateProtocolBusiness.getById(this.certificate.id);
        this.isInitializing = true;
        Object.assign(this.certificate, fresh);
        await this.$nextTick();
        this.isInitializing = false;
      } catch (e) {
        // silently ignore — conflict message is already shown
      }
    },

    scheduleAutoSave() {
      if (!this.certificate.typeOfCertificate) return;
      clearTimeout(this.saveTimer);
      this.saveStatus = 'idle';
      this.saveTimer = setTimeout(() => this.autoSave(), 1500);
    },

    async autoSave() {
      this.isSaving = true;
      this.saveStatus = 'saving';
      try {
        const saved = await CertificateProtocolBusiness.saveOne(this.certificate);
        this.certificate.version = saved.version;
        if (!this.certificate.id) {
          this.certificate.id = saved.id;
        }
        this.saveStatus = 'saved';
        setTimeout(() => {
          if (this.saveStatus === 'saved') this.saveStatus = 'idle';
        }, 3000);
      } catch (e) {
        if (e && e.message === 'error.concurrent-edit') {
          this.saveStatus = 'conflict';
          await this.reloadCertificate();
        } else {
          this.saveStatus = 'error';
        }
      } finally {
        await this.$nextTick();
        this.isSaving = false;
      }
    },

  }

}
</script>

<style scoped>

  .certificate-0 {
      background-color: #edf0f5;
  }

  .certificate-1 {
      background-color: #c2c9d5;
  }


  .save-status {
      font-size: 0.8rem;
      display: flex;
      align-items: center;
      gap: 0.3rem;
  }

  .save-status--saving { color: #888; }
  .save-status--saved  { color: #22863a; }
  .save-status--conflict,
  .save-status--error  { color: #e40021; font-weight: 600; }


</style>

<style>

  .card-body {
      width: 100% !important;
  }
</style>